import React, { useEffect, useState } from "react";
import PageWrapper from "../../components/PageWrapper";
import { Stack } from "@mui/material";
import { IPortalRouteOptions } from "../../shared/types/shared/routes/routeTypes";
import { BrokenImageOutlined } from "@mui/icons-material";
import { IPNPlanSubmission, PNPlanSubmissionState } from "../../shared/types/dispatch/IFailedPnMetrics";
import { FailedPnOutstandingTable } from "../../components/dispatch/failed-pn/FailedPnOutstandingTable";
import { PermanentlyFailedPnTable } from "../../components/dispatch/failed-pn/PermanentlyFailedPnTable";
import { SuccessfullySubmittedPnTable } from "../../components/dispatch/failed-pn/SuccessfullySubmittedPnTable";
import { useGetPNPlanSubmissionsQuery, useResubmitPNPlanMutation } from "../../shared/api/DispatchApi";
import { useToastAlertContext } from "../../components/ToastAlert";

const FailedPNPage: React.FC<IFailedPNPage> = () => {
    const [outstandingPNSubmissions, setOutstandingPNSubmissions] = useState<IPNPlanSubmission[]>([])
    const [failedPNSubmissions, setFailedPNSubmissions] = useState<IPNPlanSubmission[]>([])
    const [successfulPNSubmissions, setSuccessfulPNSubmissions] = useState<IPNPlanSubmission[]>([])

    const pollingInterval = 300000 // Poll every 5 minutes
    const { data: pnPlanSubmissions, isLoading, refetch } = useGetPNPlanSubmissionsQuery(undefined, { pollingInterval })
    const [refetchScheduled, setRefetchScheduled] = useState<boolean>(false)
    const [resubmitPNPlan] = useResubmitPNPlanMutation();
    const { popToast } = useToastAlertContext();

    const triggerDelayedRefetch = () => {
        if (!refetchScheduled) {
            setRefetchScheduled(true)
            setTimeout(() => {
                refetch()
                setRefetchScheduled(false)
            }, 10000);
        }
    }
    const clickResubmit = async (pn: IPNPlanSubmission) => {
        const result = await resubmitPNPlan(pn);
        if ('error' in result) {
            popToast("Something went wrong went resubmitting PN Plan for " + pn.unitID, "error")
        } else {
            popToast("PN Plan for " + pn.unitID + " Resubmitted", "success")
            triggerDelayedRefetch()
        }
    }

    useEffect(() => {
        if (pnPlanSubmissions) {
            const outstanding = pnPlanSubmissions.filter(submission => submission.state === PNPlanSubmissionState.Outstanding)
            const failed = pnPlanSubmissions.filter(submission => submission.state === PNPlanSubmissionState.Failed)
            const successful = pnPlanSubmissions.filter(submission => submission.state === PNPlanSubmissionState.Succeeded)
            setOutstandingPNSubmissions(outstanding)
            setFailedPNSubmissions(failed)
            setSuccessfulPNSubmissions(successful)
        }
    }, [pnPlanSubmissions])

    return (
        <PageWrapper title="Failed PN" loaded={!isLoading}>
            <Stack direction="column" spacing={1}>
                <FailedPnOutstandingTable data={outstandingPNSubmissions} onClickResubmit={clickResubmit} />
                <PermanentlyFailedPnTable data={failedPNSubmissions} />
                <SuccessfullySubmittedPnTable data={successfulPNSubmissions}/>
            </Stack>
        </PageWrapper>
    );
}

export interface IFailedPNPage {

}

const FailedPNPageConfig: IPortalRouteOptions = {
  relativeUrl: "failedPn",
  page: <FailedPNPage />,
  navDisplay: {
    title: "Failed PN",
    icon: <BrokenImageOutlined />
  }
}

export default FailedPNPageConfig;
